export default {
  isEditing: true,
  isValid: false,
  url: null,
  nameService: null,
  format: null,
};
